const filterSubservices = (subServices, selectedTherapist, isFollowUp) => {
  let returnedSubservices = subServices.reduce((acc, current) => {
    const treatments = current.treatments.filter((tr) => tr.isFirstAppointment === !isFollowUp);

    if (treatments) {
      if (treatments.length === 1) {
        acc.push({
          ...current,
          treatments,
          treatment: treatments[0],
        });
      }

      if (treatments.length > 1) {
        treatments.map((t) => acc.push({
          ...current,
          treatments,
          treatment: t,
        }));
      }
    }

    return acc;
  }, []);

  if (selectedTherapist && selectedTherapist.services && selectedTherapist.services.length > 0) {
    returnedSubservices = returnedSubservices.filter((rsbs) => selectedTherapist.services.filter(
      (s) => (
        rsbs.client_type2Id === s.subdisciplineID
          && rsbs.treatment.treatmentId === s.treatmentID
      ),
    ).length > 0);
  }

  return returnedSubservices;
};

export default filterSubservices;
